import { lazy, Suspense } from 'react';
import { ErrorCatch } from './ErrorCatch'
import { LazyLoadingAnimation } from './Lazy'

const SettingsListBase = lazy(() => import("./SettingsList"));
// ================================================================================================
export const SettingsList = (props: any) => {
    return (
        <ErrorCatch>
            <Suspense fallback={<LazyLoadingAnimation />}>
                <SettingsListBase {...props} />
            </Suspense>
        </ErrorCatch>
    );
}
// ================================================================================================